module.exports = __webpack_public_path__ + "img/terroir-disc-2-mobile.456dea43.jpg";